/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, FormControl, FormLabel, Select, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaBullhorn, FaTrash, FaUserPlus } from 'react-icons/fa'
import { Button } from '../../../../../components/Button'
import { FindUser } from '../../../../../components/FindBox'
import { iConvite, iDemografia, iNomeId } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
import { ModalBase } from '../../../../../components/ModalBase'
import { ModalComunicao } from '../ModalComunicacao'
import { TableConvites } from '../Table'
import { ActionButton } from './styles'

interface iModalProps {
  isOpen: boolean
  rows: iConvite[]
  imersaoId: string
  Reload: () => void
  onClose: () => void
}

export const ModalConvitePorApp: React.FC<iModalProps> = ({ isOpen, rows, imersaoId, onClose, Reload }) => {
  const toast = useToast()
  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const [Departamentos, setDepartamentos] = useState<iDemografia[]>([])
  const [ColaboradorId, setColaboradorId] = useState('')
  const [DepartamentoId, setDepartamentoId] = useState('')

  const [Selecionados, setSelecionados] = useState<string[]>([])
  const [ModalComunicacaoIsOpen, setModalComunicacaoIsOpen] = useState(false)

  function getColaboradores(): void {
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
  }

  function getDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => setDepartamentos(res.data))
      .catch(err => console.log(err))
  }

  function ConvidarPorColabId(): void {
    appApi.post(`ImersaoExternaConvite/${imersaoId}/Colaborador?colaboradorId=${ColaboradorId}`)
      .then(() => {
        SelecionarUsuario('')
        Reload()
        toast({
          title: 'Colaborador selecionado com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
      .catch(err => console.log(err))
  }

  function ConviteByDepartamentoId(): void {
    appApi.post(`ImersaoExternaConvite/${imersaoId}/Departamento?departamentoId=${DepartamentoId}`)
      .then(() => {
        Reload()
        setDepartamentoId('')
        toast({
          title: 'Área adicionada com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
      .catch(err => console.log(err))
  }

  function ConvidarTodosColaboradores(): void {
    appApi.post(`ImersaoExternaConvite/${imersaoId}/Todos`)
      .then(() => {
        Reload()
        toast({
          title: 'Colaboradores foram adicionados com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
      .catch(err => console.log(err))
  }

  function onCheck(id: string, ids?: string[]): void {
    if (ids) {
      const copy = [...Selecionados]
      if (Selecionados.length === ids.length) {
        setSelecionados([])
      } else {
        for (let i = 0; i < ids.length; i++) {
          if (copy.find(e => e === ids[i]) === undefined) {
            copy.push(ids[i])
          }
        }
        setSelecionados(copy)
      }
    } else {
      const copy = [...Selecionados]
      if (copy.find(e => e === id) === undefined) {
        copy.push(id)
        setSelecionados(copy)
      } else {
        setSelecionados([])
        const filtrado = copy.filter(e => e !== id)
        setSelecionados(filtrado)
      }
    }
  }

  function onDeleteConvites(): void {
    appApi.post('ImersaoExternaConvite/DeletarVarios', Selecionados)
      .then(() => {
        Reload()
        setSelecionados([])
      })
      .catch(err => console.log(err))
  }

  function SelecionarUsuario(id: string): void {
    setColaboradorId(id)
  }

  useEffect(() => {
    getColaboradores()
    getDepartamentos()
  }, [])

  return (
    <ModalBase
      Titulo="Convite por usuário"
      Subtitulo="Utilize os filtros para selecionar apenas os convites que desejar. Você pode filtrar por área ou nome, selecionando os convites que desejar. Poderá também clicar na barra de seleção e adicionar todos os convites que estão aparecendo na lista a partir dos filtros realizados."
      isOpen={isOpen}
      onClose={onClose}
      Width='65rem'
    >
      <ModalComunicao
        isOpen={ModalComunicacaoIsOpen}
        imersaoId={imersaoId}
        onClose={() => setModalComunicacaoIsOpen(false)}
      />
      <Flex padding={'2rem'} flexDir={'column'}>
        <Flex width={'100%'}>
          <FormControl as={Flex}>
            <FormLabel width={'14rem'} fontSize={'xl'}>Convite por área</FormLabel>
            <Select value={DepartamentoId} onChange={(e) => setDepartamentoId(e.target.value)} margin={'0rem 2rem'} borderColor={'var(--Gray4)'} size='md'>
              <option value={''}>Nenhum</option>
              {
                Departamentos.map((e, i) => {
                  return (
                    <option value={e.id} key={i}>{e.nome}</option>
                  )
                })
              }
            </Select>
          </FormControl>
          <Button onClick={ConviteByDepartamentoId} VarColor='v2'>Selecionar usuários</Button>
        </Flex>
        <Flex width={'100%'} marginTop={'1rem'}>
        <FormControl alignItems={'start'} as={Flex}>
            <FormLabel width={'14.2rem'} fontSize={'xl'}>Pesquisar usuário</FormLabel>
            <Flex width={'100%'} margin={'0 2rem'}>
             <FindUser
                lista={Colaboradores.filter(e => rows?.find(r => r.email === e.email) === undefined)}
                onChoice={SelecionarUsuario}
              />
            </Flex>
          </FormControl>
          <Button VarColor='v2' onClick={ConvidarPorColabId}>Selecionar usuários</Button>
        </Flex>
        <Flex margin={'1rem 0rem'} justifyContent={'space-around'}>
          <ActionButton theme={'#75AAE0'} onClick={() => setModalComunicacaoIsOpen(true)}>
            <FaBullhorn size={32} />
            <Flex flexDir={'column'}>
              <span>Adicionar comunicação</span>
              <small>Você pode adicionar textos, imagens e vídeos</small>
            </Flex>
          </ActionButton>
          <ActionButton onClick={ConvidarTodosColaboradores} theme={'var(--v2)'}>
            <FaUserPlus size={32} />
            <Flex flexDir={'column'}>
              <span>Selecionar todos os colaboradores cadastrados</span>
            </Flex>
          </ActionButton>
        </Flex>

        {
          (rows !== undefined && rows.length > 0) && (
            <>
              <Flex marginBottom={'1rem'} fontWeight={'400'} justifyContent={'space-between'} alignItems={'center'}>
                <h3>Usuários selecionados</h3>
                <Button leftIcon={<FaTrash />} VarColor={'terc3'} onClick={onDeleteConvites}>Excluir convites selecionados</Button>
              </Flex>
              <TableConvites
                isEdit
                rows={rows?.filter(e => e.status !== 'Visualizado')}
                onCheck={onCheck}
                selecionados={Selecionados}
                onSend={() => { }}
              />
            </>
          )
        }
      </Flex>
      <Flex padding={'0 1rem 1rem 0'} justifyContent={'end'}>
        <Button VarColor='Green1' size={'lg'} onClick={onClose}>Continuar</Button>
      </Flex>
    </ModalBase>
  )
}
